import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const ReportTimeSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Select,
    id: "period",
    label: "기간",
    defaultValue: "7d",
    options: [
      {
        label: "어제",
        value: "yesterday",
      },
      {
        label: "오늘",
        value: "today",
      },
      {
        label: "지난 7일",
        value: "7d",
      },
      {
        label: "지난 14일",
        value: "14d",
      },
      {
        label: "지난 30일",
        value: "30d",
      },
      {
        label: "지난 달",
        value: "last_month",
      },
      {
        label: "이번 달",
        value: "this_month",
      },
      {
        label: "기간 설정",
        value: "custom",
      },
    ],
  },
];
